import { useState } from 'react';

import Card from 'react-bootstrap/Card';
import { MessageContent } from './1-2-1_MessageContent';

import { formatISODatetime } from "../../utils";

export const MessageCard = ({ message, messageIdx, numMesages, history }) => {
    const [ showMessageDetail, setShowMessageDetail ] = useState(false);

    const [ messageCopiedToClipboard, setMessageCopiedToClipboard] = useState(-1);
    const copyToClipboard = (clickEvent) => {
        const messageId = parseInt(clickEvent.target.getAttribute('messageid'));
        const selector = `div[messageid="${messageId}"]`;
        const content = document.querySelector(selector).innerText;
        navigator.clipboard.writeText(content)
            .then(() => setMessageCopiedToClipboard(parseInt(messageId)))
            .then(() => setTimeout(() => {
                setMessageCopiedToClipboard(-1);
            }, 1500))
    }

    const tryAgain = () => {
        document.getElementById('humanInputTextarea').value = 'Try again';
        document.getElementById('submitQueryButton').click();
    }

    const isHuman = message.type === 'human';
    const isMessageCopied = messageCopiedToClipboard === messageIdx;
    const showTryAgain = !isHuman && messageIdx === numMesages-1;

    return (
        <div
            className={`d-flex ${isHuman ? 'justify-content-end' : 'justify-content-start'}`}
            key={`messageCard${messageIdx}`}
        >
            <div className={`ml-auto ${isHuman ? 'ml-10p' : 'mr-10p'}`}>
                <Card
                    id={message.content==='PLACEHOLDER' ? `messageCardPlaceholder` : `messageCard${messageIdx}`}
                    className={`${isHuman ? 'message-card-human' : 'message-card-ai'} m-2 p-3`}
                >
                    <Card.Subtitle className="pb-2 text-muted">
                        <i className={isHuman ? 'bi-person' : 'bi-robot'} />
                        <i className="px-2">{formatISODatetime(message.created)}</i>
                        <i 
                            messageid={messageIdx}
                            className={`no-text-decoration float-end ${isMessageCopied ? 'px-1 bi-clipboard-check' : 'px-1 bi-clipboard'}`}
                            title="Copy to clipboard"
                            onClick={clickEvent => copyToClipboard(clickEvent)}
                        />
                        <i 
                            messageid={messageIdx}
                            className={`px-1 no-text-decoration float-end ${showMessageDetail ? 'bi-info-circle-fill' : 'bi-info-circle'}`} 
                            title={showMessageDetail ? (isHuman ? 'Show human input' : 'Show response') : (isHuman ? 'Show full query sent to LLM' : 'Show model detail')}
                            onClick={() => setShowMessageDetail(!showMessageDetail)}
                        />
                        {showTryAgain && (
                                <i 
                                    className="px-1 bi-repeat no-text-decoration float-end"
                                    title="Try again" 
                                    onClick={tryAgain}
                                />
                            )
                        }
                    </Card.Subtitle>
                    <div messageid={messageIdx}>
                        <MessageContent
                            message={message}
                            history={history}
                            showMessageDetail={showMessageDetail}
                        />
                    </div>
                </Card>
            </div>
        </div>
    )
}